import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { PlTimepickerComponent } from '@app/components/pl-timepicker/pl-timepicker.component';
import { MatInputModule } from '@angular/material/input';
import { ButtonModule } from '@app/components/button/button.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { PlPopoverModule } from '@app/components/pl-popover/pl-popover.module';
import { TwentyFourHoursToAmPmPipeModule } from '@shared/pipes/twentyFourHoursToAmPm/twentyFourHoursToAmPm.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    SharedModule,
    FormsModule,
    MatInputModule,
    ButtonModule,
    MatAutocompleteModule,
    MatOptionModule,
    PlPopoverModule,
    TwentyFourHoursToAmPmPipeModule,
  ],
  declarations: [PlTimepickerComponent],
  exports: [PlTimepickerComponent],
})
export class PlTimepickerModule {}
